+function ($) { "use strict";
	/**
	 * Rating Object
	 */
	var RatingCompagnon = function(element, options){this.initialize(element,options)};
	$.extend(RatingCompagnon.prototype,
	{
		initialize: function(element,options)
		{
			var This = this;
			this.$element = $(element);
			this.buttons  = this.$element.find('.rating-button');
			this.submit   = this.$element.find('.rating-submit');

			var results = {}
			this.buttons.each(function(){
				results[ this.value ] = {};
				results[ this.value ]['show'] = This.$element.find( $(this).attr('iaf-show') );
				results[ this.value ]['hide'] = This.$element.find( $(this).attr('iaf-hide') );
			});
			this.results = results;

			this.buttons.on('click.rating', $.proxy( this.valueClicked , this ));
			this.submit.on('click.rating', $.proxy( this.submitRating , this ));
		},

		submitRating: function(e)
		{
			e.preventDefault();
			if( this.value === null || this.value === undefined ) return;

			var data = this.$element.find('.rating-data').serializeJSON();
			if( !this.isValid(data) ) return;

			this.results[this.value].hide.hide().addClass('oculted');
			this.results[this.value].show.show().removeClass('oculted');

			// InbentaCompagnon.Assistant.rate(
			// this.value,
			// data.type,
			// data.logid,
			// data.contentid,
			// data.comment || ''
			// );
		},

		isValid: function(data)
		{
			return true;
		},

		valueClicked: function(e)
		{
      var button = (typeof e.target.value != "undefined") ? $(e.target) : $(e.target).parents(".rating-button").first();
      var next = this.$element.find( button.attr('iaf-next') );
      var hide = this.$element.find( button.attr('iaf-hide-next') );

			this.value = button.val();

			if( next ) next.show().removeClass('oculted');
			if( hide ) hide.hide().addClass('oculted');

			if( button.attr('iaf-submit') )
				this.submitRating(e);
		}
	});
	window.InbentaCompagnon.RatingCompagnon = RatingCompagnon;


	/**
	 * JQuery utils
	 */
	$.fn.inbentaRatingCompagnon = function (options) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data = $this.data('inbenta.rating');
	      if(!data) $this.data('inbenta.rating',new RatingCompagnon(this,options));
	    });
  	};

}(window.jQuery);
